import { graphql } from '@/graphql/codegen';

export const getSeminarsQueryDocument = graphql(/* GraphQL */ `
  query getSeminars($seminar: GetSeminarsInput!) {
    seminars(seminarsInput: $seminar) {
      name
      id
      date
      endDate
      lector
      city
      duration
      capacity
      deposit
      substituteCapacity
      registeredParticipants
      author {
        email
        firstName
        lastName
        phone
      }
      price
      type
      theoryDuration
      practiceDuration
    }
  }
`);
